module.exports = __webpack_public_path__ + "img/asd.15522bd9.svg";